module.exports = __webpack_public_path__ + "media/images/background_altruism-329b2a40baa654acada1eea2352c7855.jpg";